import HasMake from '../services/hash.service';
import HashMake from '../services/hash.service';

const TOKEN_KEY = 'token'
const REFRESH_TOKEN_KEY = 'refreshtoken'
const USER_DETAILS = 'userDetails'
const LOCALE = 'locale'
const USER_DETAILS_ADDRESS = 'userDetailsAddress'
const VIRTUAL_LOGIN_DETAILS = 'vud'
const PREVIOUS_URL = 'previousUrl'
const ANONYMOUS_USER = 'anonymous'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
    getToken() {
        if(localStorage.getItem(TOKEN_KEY)){
            return HashMake.decrypt(localStorage.getItem(TOKEN_KEY))
        }else{
            return localStorage.getItem(TOKEN_KEY)
        }        
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, HashMake.encrypt(accessToken))
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY)
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY)
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, HashMake.encrypt(refreshToken))
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    },

    getUserDetails() {
        if( localStorage.getItem(USER_DETAILS) ) {
            return HashMake.decrypt(localStorage.getItem(USER_DETAILS));
        }

    },

    getUserDetailsAddress() {
        if( localStorage.getItem(USER_DETAILS_ADDRESS) ) {
            if(localStorage.getItem(USER_DETAILS_ADDRESS) != 'undefined') {
                return HasMake.decrypt(localStorage.getItem(USER_DETAILS_ADDRESS));
            } else {
                return [];
            }
        }
    },

    removeUserDetails() {
        localStorage.removeItem(USER_DETAILS)
    },

    getLocale() {
        return (localStorage.getItem(LOCALE)) ? localStorage.getItem(LOCALE).substring(0,localStorage.getItem(LOCALE).indexOf('_')) : process.env.VUE_APP_I18N_LANG
    },

    removeUserDetailsAddress() {
        localStorage.removeItem(USER_DETAILS_ADDRESS)
    },

    saveVirtualUserDetails(userDetails) {
        localStorage.setItem(VIRTUAL_LOGIN_DETAILS, HasMake.encrypt(userDetails))
    },

    getVirtualUserDetails() {
        if( localStorage.getItem(VIRTUAL_LOGIN_DETAILS) ) {
            return HasMake.decrypt(localStorage.getItem(VIRTUAL_LOGIN_DETAILS)) 
        }
    },
    
    removeVirtualUserDetails() {
        localStorage.removeItem(VIRTUAL_LOGIN_DETAILS)
    },
    
    removePrevUrl() {
        localStorage.removeItem(PREVIOUS_URL)
    },
    setGuestToken() {
        localStorage.setItem(ANONYMOUS_USER, Math.random().toString(36).substring(3,12));
    },
    getGuestToken() {
        return localStorage.getItem(ANONYMOUS_USER)
    },
    removeGuestToken() {
        if(localStorage.removeItem(ANONYMOUS_USER)) {
            localStorage.removeItem(ANONYMOUS_USER)
        }
    }
}

export { TokenService }